import { PropsWithChildren, useState } from 'react';
import useSWR from 'swr';
import { APIList } from '../../../../../../../typings/API.interface';
import { StyledUtilsProps } from '../../helpers/StyledUtils';
import SelectInput from './SelectInput';
interface Props<Resource> extends StyledUtilsProps {
  label?: string;
  name: string;
  search_key?: string;
  help?: string;
  placeholder?: string;
  search_placeholder?: string;
  getLabel?: (resource: Resource) => string;
  listResources: (filters: object) => Promise<Resource[] | APIList<Resource>>;
  listResourcesKey: (filters: object) => string;
}
const SelectResourceInput = <Resource extends {
  id: string;
  name: string;
},>({
  label,
  search_key,
  getLabel = r => r.name,
  listResources,
  listResourcesKey,
  name,
  help,
  placeholder,
  search_placeholder
}: PropsWithChildren<Props<Resource>>) => {
  search_key = search_key || 'name';
  const [search_query, setSearch] = useState('');
  const {
    data: resources
  } = useSWR<Resource[] | APIList<Resource>>(listResourcesKey(search_query ? {
    [search_key]: search_query
  } : {}), () => listResources(search_query && search_key ? {
    [search_key]: search_query
  } : {}));
  const getDisplayResourceList = () => {
    return (Array.isArray(resources) ? resources : resources?.models || []).filter(resource => getLabel(resource).toLowerCase().includes(search_query.toLowerCase()));
  };
  const display_resource_list = getDisplayResourceList();
  return <SelectInput name={name} label={label} required search placeholder={placeholder} search_placeholder={search_placeholder ?? (label ? `Find a ${label.toLowerCase()}` : undefined)} separator={false} sublte_error options={display_resource_list.map(resource_0 => ({
    value: resource_0.id,
    label: getLabel(resource_0) || resource_0.name
  })) || []} width={100} block search_term={search_query} setSearchTerm={setSearch} search_is_loading={!resources} help={help} />;
};
export default SelectResourceInput;